export default __webpack_public_path__ + "static/media/philipp-pilz-QZ2EQuPpQJs-unsplash.89e5c3d1.jpg";